<template>
  <div class="kami-charge">
    <div class="kami-charge-dialog">
      <div class="kami-charge-header">
        <div class="f18 white">购买VIP权益包</div>
        <div class="kami-charge-header-side">
          <img
            class="kami-charge-close"
            src="/static/images/view_btn_close_white.png"
            alt=""
            @click="close"
          />
        </div>
      </div>
      <div class="kami-charge-body" v-if="paymentStatus">
        <div class="kami-charge-success">
          <div class="kami-charge-success-top">
            <img src="/static/images/stu/ownInfo/ic_vip.png" alt="" />
            <div class="f20 grey9" style="margin-top: 15px;">付款成功</div>
            <div class="f16 grey9">
              你已成功购买<span>{{ productInfo ? productInfo.productName : '' }}</span>
            </div>
          </div>
          <div
            style="width: 600px;margin: 20px auto 30px;border-top: 1px solid #eee;padding-top: 20px;"
          >
            <div class="flex kami-charge-success-bottom">
              <div style="width: 192px;margin-right: 40px;">
                <p class="grey9 fb">欢迎加入我们</p>
                <p class="grey9" style="margin: 10px 0;">
                  为了向您提供更好的VIP服务，请扫码添加客服企业微信：
                </p>
                <!-- <p class="grey9">微信号：18911542692</p> -->
              </div>
              <img src="/static/images/stu/vip/qrcode.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="kami-charge-body" v-else>
        <div class="kami-charge-bottom">
          <div class="kami-charge-payment-type kami-charge-payment-weixin"></div>
          <div style="margin: 20px 0px 26px;">
            <div class="flex-start-center">
              <div class="qrcode">
                <img
                  :src="QRCode"
                  :style="{ visibility: QRCode ? 'visible' : 'hidden' }"
                  alt=""
                />
                <div
                  class="qrcode-cover overtime"
                  v-if="overtime"
                  @click="fetchQRCode"
                ></div>
                <div class="qrcode-cover loading" v-if="loading">
                  <img src="/static/images/ui/charge/loading.png" alt="" />
                </div>
              </div>
              <div>
                <div>
                  <span class="f24 text-fe8828"> ￥</span>
                  <span class="f24 text-fe8828" style="font-family: condensed;">{{
                    payInfo.price
                  }}</span>
                </div>
                <div class="f12 grey9" style="padding-left: 3px;margin-top: 10px;">
                  使用微信扫码支付
                </div>
              </div>
            </div>
          </div>
          <div class="flex-start-center">
            <span class="f12 grey9">开通即同意</span>
            <a href="/payment" target="_blank" class="f12 green"
              >《{{ pname }}用户付费协议》</a
            >
          </div>
          <div
            class="kami-charge-cost-message text-fe8828"
            :class="{ hasMessage: confirm }"
          >
            {{ confirm }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPayInfo, checkPay } from '@/api/index'

export default {
  props: ['payInfo', 'productInfo'],
  data() {
    return {
      overtime: false, // 二维码过期
      loading: true, // 读取二维码
      QRCode: '', // 二维码地址
      orderNo: '', // 订单号
      paymentStatus: false, // 是否已支付
      backCountdown: 3, // 返回倒计时
      confirm: '',
      pname: window.ConfigNew.header.name
    }
  },
  created() {
    this.fetchQRCode()
  },
  mounted() {},
  beforeDestroy() {
    clearTimeout(this.timeout)
    this.overtime = true
    this.checkPaymentStatusXHR &&
      typeof this.checkPaymentStatusXHR.cancel === 'function' &&
      this.checkPaymentStatusXHR.cancel()
  },
  methods: {
    close() {
      this.$destroy()
      this.$el.parentElement.removeChild(this.$el)
    },
    fetchQRCode() {
      this.loading = true
      this.confirm = ''
      getPayInfo(this.payInfo, res => {
        if (res.status === 1) {
          const payInfo = res.data.payInfo
          this.confirm = res.data.confirm
          this.setPaymentInfo(payInfo, true)
          this.$nextTick(() => {
            this.loading = false
          })
        } else {
          this.confirm = res.info
        }
      })
    },
    setPaymentInfo(payInfo, refresh) {
      const { code_url, out_trade_no } = payInfo
      this.QRCode = code_url
      this.orderNo = out_trade_no

      if (refresh) {
        clearTimeout(this.timeout)
        this.overtime = false
        this.timeout = setTimeout(() => {
          // 二维码过期时间20分钟
          this.overtime = true
        }, 20 * 60 * 1000)
        this.checkPaymentStatus()
      }
    },
    checkPaymentStatus() {
      if (this.orderNo) {
        this.checkPaymentStatusXHR &&
          typeof this.checkPaymentStatusXHR.cancel === 'function' &&
          this.checkPaymentStatusXHR.cancel()

        this.checkPaymentStatusXHR = checkPay(
          {
            jdcpIP: this.payInfo.jdcpIP,
            order_no: this.orderNo
          },
          res => {
            if (res.status === 1) {
              const payment_status = res.data.payment_status
              if (payment_status) {
                this.callback({
                  isPay: 1
                })
                this.paymentStatus = true
              } else {
                if (!this.overtime) {
                  // 1秒检查1次支付状态，不过现在接口平均要2.5秒返回，也就是3.5秒左右检查一次支付状态
                  clearTimeout(this.checkPaymentTimeout)
                  this.checkPaymentTimeout = setTimeout(this.checkPaymentStatus, 1000)
                }
              }
            } else {
              this.callback(res)
            }
          }
        )
      }
    }
  }
}
</script>

<style lang="less" scoped>
@font-face {
  font-family: condensed;
  src: url('/static/fonts/HELVETICANEUE_BLACKCOND.ttf');
}
@keyframes rotate {
  from {
    transform: rotateZ(0);
  }
  to {
    transform: rotateZ(360deg);
  }
}
.kami-charge {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 98;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 10;
}

.kami-charge-dialog {
  position: relative;
  width: 800px;
  border-radius: 6px;
  background-color: #f4f4f4;
  overflow: hidden;
}

.kami-charge-header {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 64px;
  padding: 0 20px;
  background-image: url('/static/images/ui/charge/ic_tankuang_bg.png'),
    linear-gradient(to right, #fe812f, #ffb800);
}

.kami-charge-header-side {
  position: absolute;
  right: 20px;
  width: 30px;
  height: 30px;
  cursor: pointer;

  .kami-charge-close {
    width: 100%;
    height: 100%;
  }
}

.kami-charge-body {
  height: 412px;
  margin: 30px;
}
.kami-charge-bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 740px;
  height: 412px;
  padding: 20px 0 16px;
  margin: 0 auto;
  border: 1px solid #e0e0e0;
  background-color: #fff;
}
.kami-charge-payment-type {
  width: 100px;
  height: 30px;
}
.kami-charge-payment-weixin {
  background-image: url('/static/images/ui/charge/ic_wechat.png');
  &.active {
    background-image: url('/static/images/stu/btn_wechat_active.png');
  }
}
.qrcode {
  position: relative;
  width: 110px;
  height: 110px;
  margin-right: 18px;
  border: 1px solid #f4f4f4;

  & > img {
    width: 108px;
    height: 108px;
  }
}
.qrcode-cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  background-repeat: no-repeat;
  background-position: center;

  &.overtime {
    background-image: url('/static/images/ui/charge/btn_refurbish.png');
    cursor: pointer;
  }

  &.loading {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      animation: rotate 3s linear infinite;
    }
  }
}
.kami-charge-cost-message {
  position: absolute;
  bottom: 60px;
}

.kami-charge-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 740px;
  height: 412px;
  padding-top: 40px;
  margin: 0 auto;
  border: 1px solid #e0e0e0;
  background-color: #fff;

  &-top {
    img {
      display: block;
      margin: 0 auto;
    }

    .grey9 {
      text-align: center;
      line-height: 30px;

      span {
        color: #fe8828;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }

  &-bottom {
    justify-content: center;
    .grey9 {
      line-height: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/UIO/holidayWorkPay/App.vue